import { Box } from "@mui/material";
import { OrderedStudio } from "entities/studios/types";
import { FC, useState } from "react";
import DragNDropTable from "shared/components/DragNDropTable";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { ArrowForwardIcon } from "shared/theme/icons/ArrowForwardIcon";
import { useSettingModuleDetails } from "../../../../context";
import { useStudioOrderingData } from "../../../../stores/useStudioOrderingData";
import SelectedGamesByStudioDrawer from "./components/SelectedGamesByStudioDrawer";

const StudioOrdering: FC = () => {
  const { isLoadingAvailableStudios } = useSettingModuleDetails();
  const { orderedStudios, setOrderedStudios } = useStudioOrderingData();
  const [selectedStudio, setSelectedStudio] = useState<OrderedStudio>();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleReorderStudios = (newItems: OrderedStudio[]) => {
    const formattedStudios = newItems.map((newItem, idx) => ({
      ...newItem,
      order: idx + 1,
    }));
    setOrderedStudios(formattedStudios);
  };

  return (
    <>
      <Box mt="1rem">
        <DragNDropTable<OrderedStudio>
          items={orderedStudios}
          onRowClick={(item) => {
            setSelectedStudio(item);
            setIsDrawerOpen(true);
          }}
          isItemsFetched={!isLoadingAvailableStudios}
          isItemsLoading={isLoadingAvailableStudios}
          noItemsMessage="No studios found"
          onItemsReorder={handleReorderStudios}
          columns={[
            {
              headerName: "Studio",
              width: "40%",
              headerPadding: "0.75rem",
              renderCell: (item) => item.name,
            },
            {
              headerName: "No. of Games",
              width: "40%",
              headerAlign: "center",
              headerPadding: "0.75rem",
              align: "center",
              renderCell: (item) => item.gamesCount,
            },
            {
              headerName: "",
              width: "11.25%",
              align: "right",
              headerAlign: "right",
              renderCell: (item) => (
                <FlexCenter>
                  <ArrowForwardIcon color={COLOR_PRIMARY_MAIN} />
                </FlexCenter>
              ),
            },
          ]}
        />
      </Box>
      <SelectedGamesByStudioDrawer
        studio={selectedStudio}
        isOpen={isDrawerOpen}
        onClose={() => {
          setSelectedStudio(undefined);
          setIsDrawerOpen(false);
        }}
      />
    </>
  );
};

export default StudioOrdering;
